import api from '@/apis/pa/pASortEmployeeAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('pASortEmployee', api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: 'id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
